
<template>
  <div class="cntnt">

    <div id="whoweare">
        <br>
        <h1 class="heading">Who We Are</h1>
        <p class="content">
We are a world class company serving the people of Assam for all round development of the State.
We supply 24x7 uninterrupted, reliable, affordable, safe and quality power to our customers.
We delight our customers by exceeding their expectations in providing 100% satisfaction in all
aspects of our service.
<br><br>
We run our operations sustainably in an environment friendly manner.
We keep our infrastructure in good health by undertaking timely preventive and predictive maintenance.
 We ensure that all our operations are safe for our employees as well as for the people whom we serve.
  We are extremely frugal in everything we do so that the cost of our operations is low. We undertake
  new projects to continuously upgrade our systems to provide quality power to our customers.
  We ensure that all our projects are completed in time with the least cost and best quality.
  Our vendors and contractors are our partners in enabling accelerated growth of Assam.
  In all our operations, we earn a reasonable profit to generate adequate surplus for taking up
  new projects to serve our customers.
  <br><br>
We are very humane in our approach to all our employees who work as a disciplined team 24x7
in the most difficult conditions while being fully accountable to the community they serve.
  <br><br>
This is who we are and this is what we will continue to be.
<br><br>
<strong>  আমাৰ পৰিচয় </strong><br>

আমি অসমবাসী লোকসকলৰ সকলো দিশৰ বিকাশৰ লক্ষ্যত উৎসর্গিত এক বিশ্বমানৰ প্রতিষ্ঠান।
আমি আমাৰ উপভোক্তাসকলক সকলো সময়তে (২৪×৭) নিৰৱচ্ছিন্ন, বিশ্বাসযোগ্য, সুৰক্ষিত, সুলভ আৰু মানসম্পন্ন বিদ্যুতৰ যোগান ধৰো।
আমাৰ সকলো ধৰণৰ সেৱাত উপভোক্তাসকলে ১০০ শতাংশ সন্তুষ্টি লাভ কৰাটো সুনিশ্চিত কৰি আমি উপভোক্তাসকলক তেওঁলোকৰ আশাকৈও বেছি সন্তুষ্টি প্রদান কৰো।
<br><br>
আমি আমাৰ সেৱাসমূহ আগবঢ়াওতে পৰিৱেশ-বন্ধু পদ্ধতি আৰু বহনক্ষম উন্নয়ণত যথোচিত গুৰুত্ব দিওঁ।
আমি সময়োপযোগী প্রতিৰক্ষামূলক আৰু নিৰোধক ৰক্ষণাবেক্ষণৰ কাম সম্পন্ন কৰি আমাৰ আন্তঃগাঁথনিসমূহক সুস্থ-সবল কৰি ৰাখো।
আমি আমাৰ কামসমূহ কৰোতে আমাৰ নিজৰ বিষয়া-কর্মচাৰীসকল, আৰু লগতে আমি সেৱা আগবঢ়োৱা লোকসকল যাতে সুৰক্ষিত হৈ থাকে, সেয়া সুনিশ্চিত কৰো।
আমাৰ সেৱাসমূহৰ বাবদ হোৱা ব্যয় নিম্নতম কৰিবলৈ আমি সকলো ক্ষেত্রতে অতিশয় মিতব্যয়ী।
আমাৰ উপভোক্তাসকললৈ মানসম্পন্ন বিদ্যুৎ যোগান অব্যাহত ৰাখিবৰ বাবে আমি আমাৰ বৈদ্যুতিক প্রণালীসমূহ নিৰন্তৰভাবে উন্নীত কৰি ৰাখো।
আমি আমাৰ প্রকল্পসমূহ সময়মতে সম্পূর্ণ কৰি তোলো আৰু লগতে প্রকল্প-ব্যয় কমাবলৈ আৰু কামবোৰৰ মানদণ্ড উন্নত কৰিবলৈ চেষ্টা কৰো।
অসমৰ বিকাশৰ গতি ত্বৰান্বিত কৰাৰ ক্ষেত্রত আমাৰ সামগ্রী যোগানকাৰী আৰু ঠিকাদাৰসকলো আমাৰ অংশীদাৰ।
আমাৰ সকলো কামত আমি এক যুক্তিসন্মত লাভহে আর্জন কৰিবলৈ চেষ্টা কৰো, যাতে আমি আমাৰ উপভোক্তাসকলক মানবিশিষ্ট সেৱা আগবঢ়াবলৈ
 প্রয়োজনীয় সম্পদ আহৰণ কৰিব পাৰো।
 <br><br>
আমাৰ সকলো বিষয়া-কর্মচাৰীয়ে আটাইতকৈ কঠিন পৰিস্থিতিতো এটা গোট হিচাপে, আৰু তেওঁলোকে সেৱা আগবঢ়োৱা লোকসকলৰ প্রতি উৎসর্গিতভাবে, কাম কৰি যায়।
আমাৰ সেই নিষ্ঠাবান বিষয়া-কর্মচাৰীসকলৰ প্রতি আমাৰ নীতি আৰু মনোভাৱ অতি মানৱীয় আৰু সহানুভূতিমূলক।
<br><br>
আমাৰ বর্তমান পৰিচয় এয়াই আৰু আমি ভৱিষ্যতেও এনে হৈ থাকিম।

</p>
</div>
<br><br><br><br><br><br><br><br><br><br>
<div id="regoffice">
  <br>
    <h1 class="heading">  Registered Office</h1>
    <p class="content">
      Assam Power Distribution Company Limited<br>
      4th Floor<br>
      Bijulee Bhawan<br>
      Paltanbazar<br>
      Guwahati - 781001<br>
      Assam - India
    </p>
  </div>
<br><br><br><br><br><br><br><br><br><br>

<div id="profile">
<br>
    <h1 class="heading">Company Profile</h1>
    <p class="content">
      Assam Power Distribution Company Limited (APDCL) is a public limited company wholly owned by the
      Government of Assam. It was incorporated on the 23rd day of October 2009 and has been registered under
      Indian Companies Act 1956.
    </p>
      <p class="content">
      The main purpose of forming the Company was to take over, manage and operate the electricity distribution system,
       assets, liabilities, undertaking of the erstwhile Assam State Electricity Board (ASEB) pursuant to a notified
       transfer scheme in terms of Part XIII of the Electricity Act, 2003.
     </p>
       <p class="content">
      The primary purpose of the Company is to undertake distribution, trading and supply of electricity in the
       state of Assam or outside in accordance with provisions of Applicable Law and all activities ancillary
       or appurtenant thereto. It has also the mandate to develop, maintain and operate the power distribution system
       in the state of Assam. In carrying out the work of supplying power, APDCL reaches every part of the state.
       From Sadiya to Mancachar and from Jonai to Lowairpowa. From the hilly areas of North Cachar Hills to the low plains of Morigaon,
       APDCL is expanding its distribution network in spite of many physical hindrances. APDCL is also implementing off-grid
       solar projects in such areas where the distribution network could not reach such as Amarpur area under Chapakhowa
       Sub-division and the 'Char' areas of Brahmaputra river.

    </p>
    <p class="content">
      APDCL is supplying power to the major industrial centers situated in Assam such as Coal India Limited (Ledo, Margherita),
      Brahmaputra Gas Cracker & Polymer Limited (Lepetkata, Dibrugarh), Cement Corporation of India Limited (Bokajan),
       Hindustan Paper Corporation Limited (Panchgram & Jagiroad), Assam Petrochemicals Limited (Namrup) etc.
       and serving the people of Assam with a consumer base of more than 64 lakhs and this is growing year
       by year.

       <!-- <br><br>
      <b-table striped hover :items="ScaleOp">
        <template v-slot:cell(Name)="data" >
          <span  v-html="data.value"></span>
        </template>
      </b-table>  -->
    </p>
  </div>
<br><br><br><br><br><br><br><br><br><br>
<div id="glance">
  <br>
    <h1 class="heading">APDCL at a Glance <span style="color:#616161   !important;font-size:1rem">(As on 31/03/2025)</span></h1>
    <p class="content">
      <ul class="a">
        <!-- <li><strong>Area :</strong> 70,000 sq. kms / 26395 villages / 214 towns</li>-->
        <li><strong>Total Number of Consumers :</strong> 70.53 Lakhs</li>
        <li><strong>Total MU Sold :</strong>	10455.91 MU (FY 24-25)</li>
        <li><strong>Total Number of 33/11 KV sub stations :</strong>	527 Nos.<!-- <span style="font-size:0.8rem"> ( Download List:	<a href="https://www.apdcl.org/website/docs/documents/Sub_Stations_LAR.pdf" target="_blank">LAR</a> | <a href="https://www.apdcl.org/website/docs/documents/Sub_Stations_CAR.pdf" target="_blank">CAR</a> | <a href="https://www.apdcl.org/website/docs/documents/Sub_Stations_UAR.pdf" target="_blank">UAR</a>)</span></li>
        <!-- <li><strong>Total Capacity of sub stations :</strong>	MVA --></li>
        <li><strong>Total length of 33 KV Lines(in ckt km) :</strong> 10382.29 KMs</li>
        <li><strong>Total length of 11 KV Lines	(in ckt km) :</strong>	104212.96 KMs</li>
        <li><strong>Total length of LT Lines (3-Phase) (in ckt km) :</strong>	137007.14 KMs</li>
        <li><strong>Total length of LT Lines (1-Phase) (in ckt km)	 :</strong>	222769.79 KMs</li>
        <li><strong>Total Number of 11KV Feeders :</strong>	2251 Nos.</li>
        <li><strong>Total Number of Distribution Transforms :</strong> 120525 Nos.</li>
        <li><strong>Total No of prepaid consumers :</strong> 38.56 lakhs</li>
        <!-- <li><strong>Total Capacity of Distribution Transforms :</strong>	 MVA</li>
        <li><strong>Annual Revenue (2019-20) :</strong> (₹ in Crores)	</li>
        <li><strong>Annual Expenses(2019-20) :</strong> (₹ in Crores)	</li> -->
        <li><strong>Administrative Structure :</strong>	3 Regions, 8 Zones, 19 Circles, 45 Divisions, 158 Sub-divisions</li>
        <!-- <li><strong>Employee Strength :</strong></li> -->
      </ul>
  </p>
</div>
<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>

<div id="Mandate">
  <br>
    <h1 class="heading">Mandate of the company</h1>
    <p class="content">
      The Company, Assam Power Distribution Company Limited was incorporated on the 23rd day of October,
      2009 as a public limited company wholly owned by the Government of Assam. The ultimate object of
      the Company is to undertake the electricity distribution, trading, supply in the state of Assam or
      outside in accordance with provisions of Applicable Law and all activities ancillary or appurtenant thereto.
      <br><br>
      The main purpose of forming the Company was to take over, manage and operate the electricity distribution system,
      assets, liabilities, undertaking of the Assam State Electricity Board (ASEB), as may be transferred to it
      pursuant to a notified transfer scheme in terms of Part XIII of the Electricity Act, 2003. Subsequently,
      the Government of Assam notified the provisional transfer scheme vide Gazette notification bearing no. PEL.
      151/2003/Pt./165 dated 10th December, 2004 as well as the final transfer scheme vide Gazette Notification PEL.
      151/2003/Pt./349 dated Dispur, the 16th August, 2005 under the Electricity Act, 2003 transferring the various
      assets, liabilities etc. of the ASEB to the Company.
      <br><br>
      The main object of the company is to develop,
      maintain and operate power distribution system in the state of Assam.
  </p>
</div>
<br><br><br><br><br><br><br><br><br><br>
<div id="vision">
  <br>
    <h1 class="heading">Our Vision</h1>
    <p class="content">
     " To be the catalyst for Holistic Growth of the State of Assam by powering Agriculture and Industry;
     lighting homes - rural and urban & generating internal resources for continually improving Technology &
      Delivery System to induce Customer Delight. "
      <br><br>
    <strong>  আমাৰ ভৱিষ্যদর্শন </strong><br>
    " অসমৰ সর্বাঙ্গীন উন্নতিত সর্বতোপ্রকাৰে সহায় কৰিবলৈ অসমৰ কৃষিখণ্ড আৰু উদ্যোগসমূহত মানসম্পন্ন বিদ্যুৎ যোগান ধৰা;
    অসমৰ গাওঁ, নগৰ-মহানগৰত বাস কৰা সকলো লোকৰে ঘৰত বিদ্যুতৰ বিতৰণ কৰা আৰু লগতে আভ্যন্তৰীণ সম্পদ আহৰণ কৰি প্রযুক্তিবিদ্যা
    আৰু যোগান পদ্ধতিৰ নিৰলস বিকাশ ঘটাই সন্মানীয় গ্রাহকসকলক তেওঁলোকে আশা কৰাতকৈও বেছি সন্তুষ্টি প্রদান কৰা। "
    </p>
</div>
<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>

<div id="mission">
    <br>
    <h1 class="heading">Our Mission</h1>
    <p class="content">
      Our Commitment is to make Assam Power Distribution Company (APDCL) the pride of ASSAM. According to
      the employees of APDCL, the following 15 KEY TASK AREAS should be undertaken to achieve Our Mission:
<ul class="a" style="padding-left:40px ">
  <li>
     Advanced planning for procurement of electricity to cater to the consumers according to demand
   </li>
 <li>
   Enhancing the capacity of the electrical sub-divisions and distribution networks by investing in infrastructure
 </li>
 <li>
   Expanding the distribution network to supply power to all the villages
 </li>
 <li>
   Increasing awareness among the consumers about economic use of electricity
 </li>
 <li>
   Replacement of Electro-Mechanical Meters with Electronic Meters
 </li>
 <li>
   To give emphasis on 100% Revenue collection, energy audit and error-free billing
 </li>
 <li>
   Engagement of Franchisee to improve the services to the consumers
 </li>
 <li>
   To set up Vigilance Cell to detect unauthorized use of electricity
 </li>
 <li>
   Training the employees for consumer-friendly behaviour
 </li>
 <li>
   To set up state-of-the-art customer care centre and carry out consumer indexing
 </li>
 <li>
   Strong resolve for financial discipline
 </li>

 <li>
   Take proper steps to increase faith among consumers
 </li>
 <li>
   Proper planning for an effective HT/LT Ratio
 </li>
 <li>
   To reduce AT & C Losses by augmenting 1-Ph lines wherever required
 </li>
 <li>
   Installation of underground cable in lieu of overhead lines
</li>
</ul>
<br>
<strong>আমাৰ লক্ষ্য</strong>
<br>
আমাৰ লক্ষ্য হ’ল অসম শক্তি বিতৰণ কোম্পানী লিমিটেডক (এ পি ডি চি এল) সমগ্র অসমে গৌৰৱ কৰিব পৰা এক প্রতিষ্ঠান হিচাপে গঢ়ি তোলা।
আমি বিশ্বাস কৰো যে তলত উল্লেখ কৰা ১৫ টা আঁচনিৰ সফল ৰূপায়নে আমাৰ লক্ষ্যক (Mission) বাস্তৱায়িত কৰাত সহায় কৰিব।
<ul class="a" style="padding-left:40px ">
<li> আমাৰ গ্রাহকসকলৰ সময়সাপেক্ষ চাহিদা পূৰণ কৰিবৰ বাবে আগতীয়া পৰিকল্পনাৰে প্রয়োজনীয় বিদ্যুৎ শক্তি ক্রয় কৰি বা আন প্রকাৰে যোগাৰ কৰি ৰখা।</li>
<li> আন্তঃগাঁথনি উন্নয়নত বিনিয়োগ কৰি বৈদ্যুতিক উপ-সংমণ্ডল আৰু বিতৰণ নেটৱর্ক উপযুক্তভাবে শক্তিশালী কৰি তোলা।  </li>
<li> আমাৰ বিতৰণ নেটৱর্কৰ প্রসাৰ ঘটাই অসমৰ সকলো গাওঁ-নগৰত পর্য্যাপ্ত বিদ্যুৎ যোগানৰ ব্যৱস্থা কৰা।</li>
<li> বিজুলী শক্তিৰ মিতব্যয়ী ব্যৱহাৰ সম্পর্কত গ্রাহকসকলৰ মাজত সজাগতা বৃদ্ধি কৰা।</li>
<li> ইলেক্ট্র-মেকানিকেল মিটাৰসমূহ সলনি কৰি সেইবোৰৰ ঠাইত ইলেক্ট্রনিক মিটাৰ স্থাপন কৰা।৷</li>
<li> ১০০ শতাংশ ৰাজহ আহৰণ, এনার্জি অডিট (Energy Audit) আৰু গ্রাহকে সঠিক বিল পোৱাৰ ব্যৱস্থা কৰা। </li>
<li> প্রয়োজন সাপেক্ষে ফ্ৰেনচাইজি (Franchisee) নিযুক্তিকৰণৰ দ্বাৰা গ্ৰাহকসকললৈ উন্নততৰ সেৱা আগবঢ়োৱাৰ ব্যৱস্থা কৰা।  </li>
<li> অকর্তৃত্বশীলভাবে বিদ্যুৎ ব্যৱহাৰ কৰাসকলক চিনাক্তকৰণ কৰি শাস্তিমূলক ব্যৱস্থা গ্রহণ কৰিবলৈ তদাৰকী কোষ (Vigilance Cell) গঠন কৰা। </li>
<li> এ পি ডি চি এল-ৰ বিষয়া-কর্মচাৰীসকলক অধিক গ্রাহক-বন্ধু হিচাপে গঢ়ি তুলিবলৈ উপযুক্ত প্রশিক্ষণৰ ব্যৱস্থা কৰা।</li>
<li> গ্রাহকৰ সুবিধাৰ বাবে অত্যাধুনিক গ্রাহক সেৱা কেন্দ্র গঢ়ি তোলা আৰু গ্রাহক সূচীকৰণ (Consumer Indexing) কাম সম্পূর্ণ কৰা।</li>
<li> এ পি ডি চি এল-ত সুদৃঢ় বিত্তীয় অনুশাসন গঢ়ি তোলা। </li>
<li> বিদ্যুৎ গ্রাহকসকলৰ মনত এ পি ডি চি এল সম্পর্কত বিশ্বাস আৰু আস্থা গঢ়ি তোলা। </li>
<li> HT/LT অনুপাত সঠিক হিচাপত ৰাখিবলৈ মাষ্টাৰ প্লেন তৈয়াৰ কৰি তাক কার্য্যকৰী কৰা। </li>
<li> ছিংগল ফেজ লাইনক অধিক ফেজৰ লাইনলৈ পৰিবর্তন কৰি এ টি এণ্ড চি ক্ষতি (AT&C Loss) হ্ৰাস কৰা।</li>
<li> পৰিবাহীৰ ক্ষেত্রত অ'ভাৰহেড লাইনৰ সলনি ভূমিতলীয় কেবল (Underground Cable) বহুওৱা।</li>
</ul>
</p>
</div>

<br><br><br><br><br><br><br><br><br><br><br>
<!--
<div id="minister">
    <br>
    <h1 class="heading">Minister</h1>

  <h4 class="content">Shri Prasanta Phukan</h4><br>
<p class="content">  Hon'ble Power Minister of Assam<br>

  Janata Bhawan, Dispur<br>
  Guwahati - 781006<br>

</p>
</div>-->

<br><br><br><br><br><br><br><br><br><br><br>
<div id="bod">
    <br>
  <h1 class="heading">Board Of Directors</h1>
  <p class="content">

  <!-- <ol>
      <li>  Shri Jishnu Barua, IAS, Chairman, APDCL, Bijulee Bhawan, Paltanbazar, Guwahati - 781001.</li>
      <li>  Shri S. K. Sinha, IAS, Principal Secretary, Finance Department, Dispur, Guwahati - 781006.</li>
      <li>  Shri Niraj Verma, IAS, Principal Secretary, Power(Elec.) Department, Dispur, Guwahati - 781006.</li>
      <li>  Shri Rakesh Kumar, IAS, Managing Director, APDCL, Bijulee Bhawan, Paltanbazar, Guwahati - 781001.</li>
      <li>  Dr. Pradip Thakuria, Swaraj Residency, Block-A 6(B), Ganeshguri, Hengrabari Road, Dispur, Guwahati - 781006.</li>
      <li>  Shri Tarun Baruah Moran, Changmaigaon, P.O. Hukanpukhuri, Tinsukia - 786146.</li>
  </ol> -->

  <b-table style= "text-align:left" responsive :items="getBoardDirector" :fields="BoardDirectorFields"></b-table>
    </p>
</div>

<!-- <br><br><br><br><br><br><br><br><br><br><br>

<div id="chairmsg">
    <h1 class="heading">Chairman's Message</h1>

  <h4 class="content">Shri Vinod Kumar Pipersenia, IAS (Retd.)</h4>
<p class="content">  Chairman, APDCL</p>
<p class="content">
  <br>

</p>
</div>

<br><br><br><br><br><br><br><br><br><br><br>
<div id="mdmsg">
    <h1 class="heading">MD's Message</h1>

  <h4 class="content">Shri Rakesh Agarwala, IAS</h4>
  <p class="content">Managing Director, APDCL</p>
<p class="content">
  All of you are aware of the difficult time faced by the Company in wake of COVID-19.
   Being an essential service, we are obligated to ensure proper supply.
   Poor collection vis-à-vis heavy fixed cost requirement like power purchase,
   pay & allowances, R&M etc. has led to accumulation of dues against various agencies
   supplying power to the tune of Rs. 1250 Crore. With no respite in payment obligation there is
   every likelihood of non-scheduling of power in the eventuality of non-payment of dues in time.
   It needs no mention that such a precarious situation will only add to worse.
   On perusal of records, it is observed that many high valued consumers are being allowed to enjoy
   the service even after non-payment for a prolonged period of time. Such act of leniency is very
   unbecoming on part of senior level officials.
   In view of the aforementioned, it is urged upon all to pull the s ocks and take all measures
   within the ambit of law to ensure maximum collection emphasizing on arrear prior to April, 2020.
   It needs no mention that inadequate collection may lead to non-payment of Salary and thereby
   disenchantment amongst the workforce discharging 24x7 non-stop duties even in these difficult hours.
</p>
</div> -->

<br><br><br><br><br><br><br><br><br><br><br>


<!-- <div id="jobchart">
    <br>
    <h1 class="heading">Job Chart and Responsibilities of Key Officials</h1>
    <b-table style= "text-align:left" responsive striped :items="getJobResponsibility" :fields="Jobfields"></b-table>
</div> -->

<br><br><br><br><br><br><br><br><br><br><br>
<div id="adminh">
    <br>
    <h1 class="heading">Administration Hierarchy</h1>
    <p class="content">
      At the headquarter of the company there are the following wings who in turn functions under the administrative control and supervision
      of the Chairman and the Managing Director.
      <ol>
        <li>Technical wing is headed by CGM(D&S), LAR, CAR, UAR</li>
        <li>Materials Management, Projects Planning & Design wing is headed by CGM(PP&D)</li>
        <li>Rural Electrification wing is headed by CGM(RE)</li>
        <li>Commercial Revenue, Commercial Tariff and Energy Efficiency wing is headed by CGM(Com. & EE)</li>
        <li>Customer Relations, Marketing & Safety wing is headed by CGM(CR, Marketing & Safety)</li>
        <li>Human Resource Development wing is headed by CGM(HRA)</li>
        <li>Finance & Accounts wing is headed by CGM(F&A)</li>
        <li>Project Management wing is headed by Director(PMU)</li>
        <li>Vigilance & Security wing is headed by CGM(Anti Theft and Security)</li>
        <li>Medical wing is headed by Chief Medical Officer(CMO)</li>
      </ol>
 In order to reach out to the consumers in a more inclusive manner, the Company has bifurcated its electricity distribution operation into three regions headed by CGM(D&S)
 <ol>
   <li>Lower Assam Region (LAR)</li>
   <li>Central Assam Region (CAR)</li>
   <li>Upper Assam Region (UAR)</li>
</ol>
 These regions have been further divided into 8 (Eight) Zones with each zone being headed by a General Manager(GM)
<ol>
    <li>Guwahati Zone under LAR</li>
    <li>Rangia Zone under LAR</li>
    <li>Bongaigaon Zone under LAR</li>
    <li>Nagaon Zone under CAR</li>
    <li>Tezpur Zone under CAR</li>
    <li>Silchar Zone under CAR</li>
    <li>Jorhat Zone under UAR</li>
    <li>Dibrugarh Zone under UAR</li>
  </ol>

 These 8 (Eight) zones have been further divided into 19 (Nineteen) numbers of Electrical Circles with each circle being headed by a
 Chief Executive Officer (CEO) in the rank of DGM (Deputy General Manager)
<ol>
  <li>Guwahati Electrical Circle - I under Guwahati Zone</li>
  <li>Guwahati Electrical Circle - II under Guwahati Zone</li>
  <li>Rangia Electrical Circle under Rangia Zone</li>
  <li>Mangaldoi Electrical Circle under Rangia Zone</li>
  <li>Bongaigaon Electrical Circle under Bongaigaon Zone</li>
  <li>Kokrajhar Electrical Circle under Bongaigaon Zone</li>
  <li>Barpeta Electrical Circle under Bongaigaon Zone</li>
  <li>Nagaon Electrical Circle under Nagaon Zone</li>
  <li>Morigaon Electrical Circle under Nagaon Zone</li>
  <li>KANCH Electrical Circle under Nagaon Zone</li>
  <li>Tezpur Electrical Circle under Tezpur Zone</li>
  <li>North Lakhimpur Electrical Circle under Tezpur Zone</li>
  <li>Cachar Electrical Circle under Silchar Zone</li>
  <li>Badarpur Electrical Circle under Silchar Zone</li>
  <li>Jorhat Electrical Circle under Jorhat Zone</li>
  <li>Golaghat Electrical Circle under Jorhat Zone</li>
  <li>Sivasagar Electrical Circle under Jorhat Zone</li>
  <li> Dibrugarh Electrical Circle under Dibrugarh Zone</li>
  <li>Tinsukia Electrical Circle under Dibrugarh Zone</li>
</ol>

 Each Circle is further divided into Electrical Divisions.There are total of 45 (Forty Five) Electrical Divisions under APDCL.
 The Divisions are being headed by an Assistant General Manager (AGM).
<br><br>
Each Division is further divided into Electrical Sub-Divisions. There are total 158 (One Hundred Fifty Eight) Electrical Sub-Divisions under APDCL.
The Sub-Divisions are being headed by a Sub Divisional Engineer (SDE) in the rank of Deputy Manager (DM) / Assistant Manager (AM).
<br><br>
 Also to cater the needs of the industrial consumers properly,
 17 numbers of IRCAs (Industrial Revenue Collection Areas) have been established throughout
 Assam with each IRCA being headed by an Area Manager.

<br><br>
 The Sub-Divisions and IRCAs are main revenue units of APDCL.
<br><br>
    </p>
</div>

<br><br><br><br><br><br><br><br><br><br><br>
<!-- <div id="scaleop">
    <h1 class="heading">Scale of Operations</h1>

</div> -->

<br><br><br><br><br><br><br><br><br><br><br>
<div id="gmap">
    <br>
    <h1 class="heading">Geographical Map</h1>
    <p class="content">
      <b-img src="../assets/gmap.jpg" style="width:75%"/>
    </p>
</div>

<br><br><br><br><br><br><br><br><br><br><br><br><br><br>
<div id="pmap">
    <br>
    <h1 class="heading">Power Map</h1>
    <p class="content">
      <b-img src="../assets/pmap.jpg" style="width:75%" />
    </p>
</div>
<br><br><br><br><br><br><br><br><br><br><br>
</div>
</template>

<style scoped="true">
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 0rem;
   text-transform: uppercase;

}
.content{
    text-align: justify;
line-height: 1.8rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;


}
#vision{
  transition: 1s;
}
table{
  text-align: left !important;
}
ul.a {
  list-style-type: circle;
}
@media (max-width: 768px) {
  .cntnt{
    box-shadow: none;
    padding:10px 30px 10px 30px;
  }
  .content{
    margin-right: 60px;
  }
  }

  @media (max-width: 576px) {
    .marginTop-250px{
      margin-top: -250px;
    }
  }
</style>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {

data() {
  return {

    ScaleOp: [
      { Name: 'No. of 33/11 kV Sub-Stations (<span style="font-size:0.8rem"> Download List:	<a href="https://www.apdcl.org/irj/go/km/docs/internet/ASSAM/webpage/PDF/Sub_Stations_LAR.pdf" target="_blank">LAR</a> | <a href="https://www.apdcl.org/irj/go/km/docs/internet/ASSAM/webpage/PDF/Sub_Stations_CAR.pdf" target="_blank">CAR</a> | <a href="https://www.apdcl.org/irj/go/km/docs/internet/ASSAM/webpage/PDF/Sub_Stations_UAR.pdf" target="_blank">UAR</a></span>)', Quantity: '347 Nos'},
      { Name: 'Total Capacity of the Sub-Stations	', Quantity: '3016.81 MVA'},
      { Name: 'Total length of 33 KV Lines	', Quantity: '5995.88 KMs'},
      { Name: 'Total length of 11 KV Lines	', Quantity: '54706.13 KMs'},
      { Name: 'Total length of LT Lines (3-Phase)	', Quantity: '45013.13 KMs'},
      { Name: 'Total length of LT Lines (1-Phase)	', Quantity: '98670.77 KMs'},
      { Name: 'Total number of Distribution Transformers	', Quantity: '64493 Nos'},
      { Name: 'Total Capacity of Distribution Transformers	', Quantity: '4484.31 MVA'},
    ],
      Jobfields: [
          { key: 'contact_person', label: 'Name',thStyle: {width: '20vw'} },
          { key: 'designation', label: 'Designation',thStyle: {width: '20vw'} },
          { key: 'job_allocation', label: 'Job Responsibility',thStyle: {width: '40vw'} }
        ],
        BoardDirectorFields: [
          { key: 'desc', label: 'The Honourable Directors of the Company are:' }

          ]

  }
},
computed:
{
  ...mapGetters([
    'getJobResponsibility',
    'getBoardDirector'
  ])
},
methods: {
  ...mapActions([
    'retrieveAboutContact'
  ])
},
beforeMount() {
    if(this.getJobResponsibility.length == 0) {
      this.retrieveAboutContact();
    }
},
mounted()
{
  console.log(this.getBoardDirector);
}
}
</script>
